<!-- Two compact lines, so the row keeps the table's usual height -->
<div class="flex min-w-0 max-w-[22rem] flex-col">
  @if (subjectText(); as subject) {
    <span
      data-request-title
      class="truncate text-xs font-medium leading-4 text-neutral-900"
      [title]="subject">
      {{ subject }}
    </span>
  } @else {
    <span
      data-request-title
      class="truncate text-xs italic leading-4 text-neutral-400">
      {{ 'inbox_request_no_subject_placeholder' | transloco }}
    </span>
  }
  <span
    data-request-meta
    class="truncate mt-x-sm text-[0.65rem] leading-3 text-neutral-500 rtl:text-xs2 rtl:leading-4">
    <span>{{ requestId() }}</span>
    @if (workflowType()) {
      <span class="text-neutral-300" aria-hidden="true">{{ ' · ' }}</span>
      <span [title]="workflowType()">{{ workflowType() }}</span>
    }
  </span>
</div>
